import { useState, useEffect } from 'react';
import { PaginationState } from '@tanstack/react-table';

export function useSearch() {
    const [searchTerm, setSearchTerm] = useState('');
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: 10,
    });

    // Reset pagination to page 0 when search term changes
    useEffect(() => {
        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
    }, [searchTerm]);

    return {
        searchTerm,
        setSearchTerm,
        pagination,
        setPagination,
    };
}